import { PaginationResponse } from '@/main/models/common/paginationResponse';
import {
  CompanyManufacturerRequest,
  CompanyManufacturerSaveRequest,
  DeleteCompanyManufacturerRequest
} from '@/main/models/request/companyManufacturerRequest';
import { CompanyManufacturerResponse } from '@/main/models/response/companyManufacturerResponse';
import { AxiosResponse } from 'axios';
import { ICompanyManufacturerApi } from '../base/registration/companyManufacturerApi';
import { api } from '../base';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

const baseRoute: string = 'CompanyManufacturer';

export class CompanyManufacturerApi extends ICompanyManufacturerApi {
  getCompanyManufacturerGrid(
    request: CompanyManufacturerRequest
  ): Promise<AxiosResponse<PaginationResponse<CompanyManufacturerResponse>>> {
    return api.get(`${baseRoute}`, { params: request });
  }

  saveCompanyManufacturers(
    request: CompanyManufacturerSaveRequest
  ): Promise<AxiosResponse<Result<CompanyManufacturerResponse[]>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  deleteCompanymanufacturer(
    request: DeleteCompanyManufacturerRequest
  ): Promise<AxiosResponse<Result<CompanyManufacturerResponse>>> {
    return api.delete(`${baseRoute}/delete`, { data: request });
  }

  getDomain(
    request: CompanyManufacturerRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain/${request.companyGuid}`);
  }
}
